export const ACCEPT_IMAGE_TYPES = ["image/png", "image/jpeg"];

export const ACCEPT_IMAGE_TYPES_STRING = ACCEPT_IMAGE_TYPES.join(", ");
